import { useMutation } from "react-query";
import queryKeys from "../../../constants/queryKeys";
import historicAuditService from "../../services/historicAuditService";
import reactQueryUtils from "../../../utils/reactQueryUtils";

const { client } = reactQueryUtils

const useUpdateHistoricAudit = () => 
    useMutation(
        (historicAudit) => historicAuditService.update(historicAudit.historicAuditId, historicAudit),
        {
            onMutate: async ({ siteExternalId, ...historicAudit }) => {
                const queryKey = [queryKeys.siteHistoricAudits, siteExternalId];

                await client.cancelQueries(queryKeys.siteHistoricAudits);

                const previousHistoricAudit = client.getQueryData(queryKeys.siteHistoricAudits);

                client.setQueryData(queryKeys.siteHistoricAudits, (old) => ({
                    ...old,
                    ...historicAudit,
                }));

                return { previousHistoricAudit, queryKey };
            },
            onError: (_err, _newDocument, context) => {
                if (!context) return;

                client.setQueryData(context.queryKey, context.previousHistoricAudit);
            },
            onSettled: () => {
                client.invalidateQueries(queryKeys.siteHistoricAudits);
            },
        }    
    )
export default useUpdateHistoricAudit;